import React, { useMemo } from 'react';
import { Typography, Box } from '@mui/material';
import Chart from 'react-apexcharts';
import Title from './Title';

export default function TotalChart({ todayData, totalBookings, totalTickets, ...props }) {
    const data = todayData;

    const options = { month: 'long' };
    const monthName = new Intl.DateTimeFormat('en-US', options).format(new Date());
    const chartTitle = props.name || 'Total Concluded Tickets';

    // Transform data for ApexCharts
    const chartData = useMemo(() => {
        if (!data || !Array.isArray(data)) return { categories: [], series: [] };

        const currentMonthKey = props.created ? 'TotalCreatedTickets' : 'TotalTickets';
        const lastMonthKey = props.created ? 'TotalCreatedTicketsLastMonth' : 'TotalTicketsLastMonth';

        // Transform data to use timestamps for datetime x-axis
        const series = [
            {
                name: `Current Month - ${currentMonthKey.replace('Total', '')}`,
                data: data.map((item) => ({
                    x: new Date(item.date).getTime(),
                    y: item[currentMonthKey] ?? 0,
                })),
            },
            {
                name: `Last Month - ${lastMonthKey.replace('Total', '')}`,
                data: data.map((item) => ({
                    x: new Date(item.date).getTime(),
                    y: item[lastMonthKey] ?? 0,
                })),
            },
        ];

        return { series };
    }, [data, props.created]);

    const chartOptions = {
        chart: {
            type: 'line',
            toolbar: {
                show: true,
            },
            zoom: {
                enabled: true,
            },
        },
        stroke: {
            curve: 'smooth',
            width: 2,
            dashArray: [0, 10],
        },
        xaxis: {
            type: 'datetime',
            labels: {
                datetimeUTC: false,
                format: 'MMM dd',
            },
        },
        yaxis: {
            title: {
                text: 'Tickets',
            },
        },
        colors: props.created ? ['#800080', '#FF0000'] : ['#A6ba62', '#F2c35c'],
        tooltip: {
            shared: true,
            intersect: false,
            x: {
                format: 'dd MMM yyyy',
            },
        },
        legend: {
            position: 'bottom',
            horizontalAlign: 'center',
        },
        grid: {
            borderColor: '#e7e7e7',
            strokeDashArray: 3,
        },
    };

    return (
        <Box>
            <Title>
                {monthName} - {chartTitle}
            </Title>
            <Typography variant="body2" color="textSecondary" gutterBottom>
                Total Bookings: {totalBookings} - Total Tickets: {totalTickets}
            </Typography>

            {data && data.length > 0 ? (
                <Chart options={chartOptions} series={chartData.series} type="line" height={300} width="100%" />
            ) : (
                <Typography variant="body2" color="textSecondary" align="center" sx={{ mt: 4 }}>
                    No data available
                </Typography>
            )}
        </Box>
    );
}
